<template>
  <v-container class="mt-5">
    <v-row class="align-center">
      <v-card-title> Batch Analytics </v-card-title>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="6" class="d-flex justify-end">
        <v-btn
          color="orange"
          dark
          x-large
          depressed
          rounded
          @click="createDialogOpen = true"
        >
          Create Batch
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="mb-5">
      <v-col cols="12" md="4">
        <StatusCard
          title="Safe Batches"
          :count="summary_response?.safe.number_of_batches || 0"
          :value="summary_response?.safe.total_value || 0"
          :quantity="summary_response?.safe.total_quantity || 0"
          description="Batches with sufficient time before expiry"
          color="green"
          icon="mdi-shield-check"
        />
      </v-col>
      <v-col cols="12" md="4">
        <StatusCard
          title="Expiring Soon"
          :count="summary_response?.expiring_soon.number_of_batches || 0"
          :value="summary_response?.expiring_soon.total_value || 0"
          :quantity="summary_response?.expiring_soon.total_quantity || 0"
          description="Batches approaching expiration date"
          color="amber"
          icon="mdi-shield-half"
        />
      </v-col>
      <v-col cols="12" md="4">
        <StatusCard
          title="Expired Batches"
          :count="summary_response?.expired.number_of_batches || 0"
          :value="summary_response?.expired.total_value || 0"
          :quantity="summary_response?.expired.total_quantity || 0"
          description="Batches that have passed expiration date"
          color="red"
          icon="mdi-shield-remove-outline"
        />
      </v-col>
    </v-row>

    <v-tabs v-model="selectedTab" centered color="orange">
      <v-tab v-for="tab in tabs" :key="tab.value" :href="`#${tab.value}`">
        {{ tab.label }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="selectedTab">
      <v-tab-item v-for="tab in tabs" :key="tab.value" :value="tab.value">
        <BatchTable
          :batch_response="batch_response"
          @list_updated="get_batches()"
          :getting_batches="getting_batches"
          :data_name="tab.value"
        />
      </v-tab-item>
    </v-tabs-items>
    <CreateBatchDialog
      :createDialogOpen="createDialogOpen"
      @create_closed="createDialogOpen = false"
      @create_completed="
        createDialogOpen = false;
        get_batches();
      "
    />
  </v-container>
</template>

<script>
import StatusCard from "./StatusCard.vue";
import BatchTable from "./BatchTable.vue";
import CreateBatchDialog from "./CreateBatchDialog.vue";

export default {
  components: { StatusCard, BatchTable, CreateBatchDialog },
  name: "batchAnalytics",
  data() {
    return {
      selectedTab: "all",
      tabs: [
        { value: "all", label: "All Batches" },
        { value: "safe", label: "Safe" },
        { value: "expiring-soon", label: "Expiring Soon" },
        { value: "expired", label: "Expired" },
      ],
      getting_batches: false,
      getting_batches_summaries: false,
      batch_response: [],
      summary_response: null,
      createDialogOpen: false,
    };
  },
  watch: {
    selectedTab() {
      this.get_batches();
    },
  },
  methods: {
    get_batches() {
      const status_param =
        this.selectedTab === "all" ? "" : `?status=${this.selectedTab}`;
      this.getting_batches = true;
      axios
        .get(`/api/item-batches${status_param}`)
        .then((response) => {
          this.batch_response = response.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.getting_batches = false;
        });
    },
    get_batches_summaries() {
      this.getting_batches_summaries = true;
      axios
        .get("/api/item-batches/summaries")
        .then((response) => {
          this.summary_response = response.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.getting_batches_summaries = false;
        });
    },
  },
  mounted() {
    this.get_batches();
    this.get_batches_summaries();
  },
};
</script>
